





















































































































































































































































































































































































































































































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";

import parsePhoneNumber from "libphonenumber-js";
import { isNullOrUndefined } from "util";

import { AuthState } from "@/store/auth/types";
import { NewslettersState } from "@/store/newsletters/types";

import { mixins } from "vue-class-component";
import Validation from "./validation-mixin";

import { bus } from "@/pages/transitweb/main";

@Component({
    components: {},
})
export default class Account extends mixins(Validation) {
    @State("auth") auth!: AuthState;
    @State("newsletters") newsletters!: NewslettersState;

    @Action("auth/getProfile") getProfile: any;
    @Action("auth/updateProfile") updateProfile: any;
    @Action("auth/changePassword") changePassword: any;
    @Action("auth/MFA_deactivate") deactivate: any;
    @Action("newsletters/list") newsletters_list: any;
    @Action("newsletters/subscribe") newsletter_subscribe: any;
    @Action("newsletters/unsubscribe") newsletter_unsubscribe: any;

    @Getter("auth/isAdmin") isAdmin?: boolean;

    user: any = { phone_number: "" }; // Note need to initialise mobile number with something other than undefined so the the phone_number validator parses.
    password: any = {};
    get error() {
        return this.status_message !== "";
    }

    getFormattedDate(date: string): string {
        const options = {
            weekday: "long",
            year: "numeric",
            month: "long",
            day: "numeric",
        };
        return new Date(date).toLocaleDateString("en-AU", options);
    }

    loading: boolean = false;
    status_message = "";
    status_type = "info";
    showPasswordCurrent = false;
    showPassword = false;
    showPasswordConfirm = false;
    valid_password = false;
    editing_profile = false;
    profile_modified = false;
    changing_password = false;
    security_expansion_panels = [];
    newsletters_panels = [];
    subscribe_dialog = false;
    subscribe_newsletter_slug = "";
    subscribe_newsletter_name = "";
    unsubscribe_dialog = false;
    unsubscribe_newsletter_slug = "";
    unsubscribe_newsletter_name = "";

    get passwordLastChanged() {
        var date = !isNullOrUndefined(this.user.date_password_changed)
            ? this.user.date_password_changed
            : this.user.date_joined;
        return this.getFormattedDate(date);
    }

    created() {
        var vm = this;

        this.getProfile()
            .then(function (response: any) {
                vm.user = response.data;
            })
            .catch(function (error: any) {
                //console.log(error)
                var msg = "An error has occurred. Try again shortly.";
                if (error.response.status === 429) {
                    msg = error.response.data.detail.replace(
                        "Request was throttled. Expected available in",
                        "Too many attempts. Try again in",
                    );
                }
                vm.status_message = msg;
            })
            .finally(function () {
                vm.loading = false;
            });
    }

    onUpdateProfile() {
        var vm = this;
        vm.status_message = "";
        vm.loading = true;

        // Update the phone number with the international parsed number.
        var pn = parsePhoneNumber(this.user.phone_number, "AU");
        if (!isNullOrUndefined(pn)) {
            this.user.phone_number = pn.number;
        }

        this.updateProfile(this.user)
            .then(function (response: any) {
                //console.log(response)
                vm.user = response.data;
                vm.profile_modified = false;
                vm.editing_profile = false;
                vm.status_type = "success";
                vm.status_message = "Profile successfully updated!";
            })
            .catch(function (error: any) {
                //console.log(error)
                var msg = "An error has occurred. Try again shortly.";
                if (error.response.status === 429) {
                    msg = error.response.data.detail.replace(
                        "Request was throttled. Expected available in",
                        "Too many attempts. Try again in",
                    );
                }
                if (
                    error.response.headers["content-type"] == "application/json"
                ) {
                    // Sends html error on say e-mails.
                    for (const field of Object.keys(error.response.data)) {
                        msg = error.response.data[field][0];
                        break;
                    }
                }
                vm.status_message = msg;
            })
            .finally(function () {
                vm.loading = false;
            });
    }

    onChangePassword() {
        this.status_message = "";
        this.status_type = "info";

        if ((this.$refs.form_password as any).validate()) {
            var vm = this;
            vm.loading = true;
            this.changePassword(this.password)
                .then(function (response: any) {
                    //console.log(response);
                    vm.status_type = "success";
                    vm.status_message = response.data.detail;
                    vm.changing_password = false;
                    vm.security_expansion_panels = [];
                    (vm.$refs.form_password as any).reset();
                })
                .catch(function (error: any) {
                    //console.log(error);
                    if (!isNullOrUndefined(error.response.data.detail)) {
                        if (error.response.status === 429) {
                            vm.status_type = "error";
                            vm.status_message =
                                error.response.data.detail.replace(
                                    "Request was throttled. Expected available in",
                                    "Too many attempts. Try again in",
                                );
                        } else {
                            vm.status_type = "error";
                            vm.status_message = error.response.data.detail;
                        }
                    } else {
                        vm.status_type = "error";
                        if (
                            error.response.headers["content-type"] ==
                            "application/json"
                        ) {
                            // Sends html error on say e-mails.
                            for (const field of Object.keys(
                                error.response.data,
                            )) {
                                vm.status_message =
                                    error.response.data[field][0];
                                break;
                            }
                        }
                    }
                })
                .finally(function () {
                    vm.loading = false;
                });
        }
    }

    change_mfa() {
        var vm = this;

        this.deactivate({})
            .then(function (resp: any) {
                console.log(resp);
                vm.$router.push("/MFA");
            })
            .catch(function (err: any) {
                console.log(err);
            });
    }

    list() {
        var vm = this;

        this.newsletters_list()
            .then(function (resp: any) {
                console.log(resp);
            })
            .catch(function (err: any) {
                console.log(err);
            });
    }

    subscribe(slug: string) {
        var vm = this;

        vm.status_message = "";
        vm.status_type = "info";

        this.newsletter_subscribe(slug)
            .then(function (resp: any) {
                console.log(resp);
                vm.list();
            })
            .catch(function (err: any) {
                vm.handleNewsletterError(err);
            });
    }

    openSubscribeDialog(item: any) {
        this.subscribe_newsletter_slug = item.slug;
        this.subscribe_newsletter_name = item.name;
        this.subscribe_dialog = true;
    }

    closeSubscribeDialog() {
        this.subscribe_dialog = false;
        this.subscribe_newsletter_slug = "";
        this.subscribe_newsletter_name = "";
    }

    confirmSubscribe() {
        const slug = this.subscribe_newsletter_slug;

        this.closeSubscribeDialog();
        this.subscribe(slug);
    }

    unsubscribe(slug: string) {
        var vm = this;

        vm.status_message = "";
        vm.status_type = "info";

        this.newsletter_unsubscribe(slug)
            .then(function (resp: any) {
                console.log(resp);
                vm.list();
            })
            .catch(function (err: any) {
                vm.handleNewsletterError(err);
            });
    }

    openUnsubscribeDialog(item: any) {
        if (!item.self_service_enabled || item.subscription_pending) {
            return;
        }

        this.unsubscribe_newsletter_slug = item.slug;
        this.unsubscribe_newsletter_name = item.name;
        this.unsubscribe_dialog = true;
    }

    closeUnsubscribeDialog() {
        this.unsubscribe_dialog = false;
        this.unsubscribe_newsletter_slug = "";
        this.unsubscribe_newsletter_name = "";
    }

    confirmUnsubscribe() {
        const slug = this.unsubscribe_newsletter_slug;

        this.closeUnsubscribeDialog();
        this.unsubscribe(slug);
    }

    handleNewsletterError(error: any) {
        this.status_type = "error";

        var msg = "An error has occurred. Try again shortly.";

        if (error.response && error.response.status === 429) {
            msg = error.response.data.detail.replace(
                "Request was throttled. Expected available in",
                "Too many attempts. Try again in",
            );
        } else if (
            error.response &&
            error.response.headers["content-type"] == "application/json"
        ) {
            if (!isNullOrUndefined(error.response.data.detail)) {
                msg = error.response.data.detail;
            } else {
                for (const field of Object.keys(error.response.data)) {
                    msg = error.response.data[field][0];
                    break;
                }
            }
        }

        this.status_message = msg;
    }

    trackClick(label: string) {
        (Vue as any).gtm.trackEvent({
            event: "gui",
            category: "links",
            action: "Link Clicked",
            label: label,
            //value: payload.value,
            noninteraction: true,
        });
        //console.log('Link Clicked', label)
    }

    newsletter_archives() {
        (window as any).open(
            process.env.VUE_APP_BACKEND_BASE + "/newsletters/",
        );
        this.trackClick("Newsletter Archives");
    }
}
